import React from "react";
import { css } from "@emotion/react";
import ClipLoader from "react-spinners/ClipLoader";
import PropTypes from "prop-types";

const override = css`
    display: block;
    margin: 0 auto;
`;

export const Spinner = ({ color, size, loading }) => (
    <ClipLoader color={color} loading={loading} css={override} size={size} />
);

Spinner.propTypes = {
    color: PropTypes.string,
    size: PropTypes.number,
};
